import { lazy } from 'react';

export const TenantList = lazy(() => import('./page-list'));


